<template>
    <div class="map-scroll-mask" :class="{ show: mask.show }" v-if="useMask">
        <p>{{ $t('map:useToZoomTheMap', { key: mask.key }) }}</p>
    </div>
</template>
<script>
import util from '@/common/util';
export default {
    i18next: {
        ns: 'map'
    },
    data: function() {
        return {
            useMask: false,
            mask: {
                show: false,
                key: /mac os/i.test(navigator.userAgent) ? '⌘' : 'ctrl'
            },
            contentEl: null,
            observer: null,
            hideMaskTimer: null
        };
    },
    async mounted() {
        this.contentEl = await util.getAsyncDom({ selector: '.page-content' });
        if (this.contentEl) {
            this.observer = new ResizeObserver(() => {
                this.calcUseMask();
            });
            this.observer.observe(this.contentEl);
        }
        this.$el.parentElement.addEventListener(
            'wheel',
            this.pcWheel,
            true
        );
    },
    beforeUnmount() {
        if (this.$el && this.$el.parentElement) {
            this.$el.parentElement.removeEventListener('wheel', this.pcWheel, true);
        }
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.hideMaskTimer) {
            clearTimeout(this.hideMaskTimer);
            this.hideMaskTimer = null;
        }
        this.useMask = false;
    },
    methods: {
        calcUseMask() {
            const isMobileDevice = this.platform.isMobile;
            const needScroll = window.innerHeight < this.contentEl.offsetHeight;
            this.useMask = !isMobileDevice && needScroll;
        },
        pcWheel(event) {
            if (!this.useMask) {
                return;
            }
            // console.log('map wheel', event)
            let selectRadiusListDom =
                document.getElementById('select-radius-list');
            if (
                selectRadiusListDom === event.target ||
                selectRadiusListDom?.contains?.(event.target)
            ) {
                event.stopPropagation();
                return;
            }
            if (this.hideMaskTimer) {
                clearTimeout(this.hideMaskTimer);
                this.hideMaskTimer = null;
            }
            if (event.metaKey || event.ctrlKey || event.altKey) {
                return (this.mask.show = false); // quick hide mask
            }
            event.stopPropagation();
            this.mask.show = true;
            this.hideMaskTimer = setTimeout(_ => {
                this.mask.show = false;
                this.hideMaskTimer = null;
            }, 1000);
        }
    }
};
</script>
<style lang="scss">
.map-scroll-mask {
    font-family: var(--font-normal);
    transition: opacity ease-in-out;
    background-color: rgba(0, 0, 0, 0.45);
    text-align: center;
    z-index: 2;
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 0px;
    border-width: 0px;
    margin: 0px;
    left: 0px;
    top: 0px;
    opacity: 0;
    transition-duration: opacity 0.8s;
    pointer-events: none;
    p {
        font-size: 22px;
        color: white;
        position: relative;
        margin: 0;
        top: 50%;
        transform: translateY(-50%);
        user-select: none;
    }
    &.show {
        opacity: 1;
        pointer-events: auto;
    }
}
</style>
